export const RESET_PASSWORD = 'RESET_GOBIZ/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_GOBIZ/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_GOBIZ/RESET_PASSWORD_FAILURE';
